<template>
  <transition name="fade">
    <div v-if="visible" class="confirm-mask">
      <div class="confirm-container">
        <div class="confirm-header relative">
          <h3>支付</h3>
          <i class="el-icon-close absolute" @click="confirmClose"></i>
        </div>
        <!-- 支付类型 -->
        <div class="confirm-content" v-if="payStatus === 0">
          <p>{{ paymentText }}</p>
          <div class="order-quantity flex items-center justify-center">
            <div class="Price" v-if="getPrice()">¥ {{ totalPriceDisplay }}</div>
            <el-input-number size="mini" :min="1" v-model="orderQuantity" style="width: 100px" />
          </div>
          <div class="payment-type">
            <div class="aliPay flex items-center">
              <img :src="require('@/assets/images/payment/alipay.png')" alt="">
              <span>支付宝支付</span>
              <i id="aliPay" class="el-icon-success pointer" :class="{ active: activeType === 'alipay' }" @click="changePay('alipay')"></i>
            </div>
            <!-- TODO 微信支付 -->
            <div class="wxPay flex items-center" v-if="false">
              <img :src="require('@/assets/images/payment/wxpay.png')" alt="">
              <span>微信支付</span>
              <i id="wxPay" class="el-icon-success pointer" style="cursor: not-allowed" :class="{ active: activeType === 'wxpay' }" @click="changePay('wxpay')"></i>
            </div>
          </div>
          <div class="buttons">
            <el-button type="primary" @click="handlePayment" :loading="payLoading">去支付</el-button>
          </div>
        </div>
        <!-- 生成二维码 -->
        <div class="confirm-content relative" v-else-if="payStatus === 1">
<!--          <i class="el-icon-arrow-left absolute" @click="handleBack"></i>-->
          <p style="font-weight: bold">请扫描下方二维码完成支付</p>
          <p style="font-size: 12px"><span style="font-weight: 400">注意：</span>支付未完成前，请勿离开此页面</p>
          <p v-if="countdown" class="no-wrap">请于<span style="display: inline-block;margin: 0 2px;white-space: nowrap;text-align: center;color: red;font-size: 15px">{{ formattedTime }}</span>内支付</p>
          <p style="padding: 18px 0 0;text-align: center;font-size: 13px">
            <span style="color: #ff5555;font-size: inherit" v-if="resultMessage.includes('订单不存在')">订单不存在</span>
            <span style="color: #ff5555;font-size: inherit" v-else-if="resultMessage.includes('订单已关闭')">订单已关闭</span>
            <span style="color: #ff5555;font-size: inherit" v-else-if="resultMessage.includes('支付失败')">支付失败或超时，交易关闭</span>
            <span style="color: #ff5555;font-size: inherit" v-else-if="resultMessage.includes('支付超时')">支付超时</span>
            <span style="color: #555555;font-size: inherit" v-else>{{ resultMessage }}</span>
          </p>
          <div class="text-center" style="width: 150px;height: 150px;margin: 10px auto 4px;">
            <QRCode v-if="!showInvalidCode" :qrUrl="payData.qrcode" :qrLogo="activeType === 'alipay' ? require('@/assets/images/payment/alipay.png')  : require('@/assets/images/payment/wxpay.png')" :errorText="errorText" />
            <div class="relative" style="width: 150px;height: 150px" v-else>
              <img width="150" height="150" :src="require('@/assets/images/payment/qrcode.png')" alt="" />
              <div class="absolute qrcode-mask flex-column items-center justify-center">
                <div class="reinitiate-btn" @click="handleBack">重新支付</div>
                <p>二维码已过期</p>
              </div>
            </div>
          </div>
          <p style="padding-bottom: 18px;font-size: 12px">{{ activeType === 'alipay' ? '支付宝扫一扫支付' : '微信扫一扫支付' }}</p>
        </div>
        <!-- 支付成功 -->
        <div class="confirm-content" v-else-if="payStatus === 2">
          <h4 style="font-size: 15px">支付成功！</h4>
          <h4 style="padding: 50px 0">您的{{ payType }}{{ payType === '人才报告' || payType === '引文报告' ? '下载次数已更新，可以继续下载。' : '访问次数已更新，可以继续访问。' }}</h4>
          <div class="buttons" style="margin: 0 0 10px">
            <el-button type="primary" @click="close">我知道了</el-button>
          </div>
        </div>

        <!--- test -->
        <div style="padding: 20px;font-size: 14px" v-if="false">
          <hr style="border: 1px solid red" >
          <div class="flex items-center">
            <span>切换状态：</span>
            <el-button @click="payStatus = 0">0</el-button>
            <el-button @click="payStatus = 1">1</el-button>
            <el-button @click="payStatus = 2">2</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QRCode from '@/components/QRCode.vue';
import { alipayQrcodeApi, alipayStatusApi, alipayCloseApi } from "@/api/payment";
import { getQuotaObj } from '@/utils/permissionFn';

export default {
  name: 'paymentDialog',
  props: {
    payType: {
      type: String,
      required: true,
      validator: function (value) {
        const allowedValues = ['成果分析', '需求分析', '专家查询', '技术问答', '人才报告', '引文报告', '人才详情'];
        return allowedValues.includes(value);
      }
    }
  },
  components: {
    QRCode
  },
  data() {
    return {
      userId: '', // userId
      visible: false, // dialog
      orderQuantity: 1, // 购买数量
      subject: '', // 成果分析 achievement、需求分析 requirement、专家查询 scholarSearch、技术问答 technicalQA、人才报告 scholarReport、引文报告 citeReport、人才详情 scholarDetail
      dialogEnum: {
        '成果分析': { prefix: `您的"成果分析"访问次数已达上限，如需继续使用，` },
        '需求分析': { prefix: `您的"需求分析"访问次数已达上限，如需继续使用，` },
        '专家查询': { prefix: `您的"专家查询"访问次数已达上限，如需继续使用，` },
        '技术问答': { prefix: `您的"技术问答"访问次数已达上限，如需继续使用，` },
        '人才报告': { prefix: `您的"人才报告"下载次数已达上限，如需继续下载，` },
        '引文报告': { prefix: `您的"引文报告"下载次数已达上限，如需继续下载，` },
        '人才详情': { prefix: `您的"人才详情"访问次数已达上限，如需继续访问，` },
      },
      activeType: "alipay", // alipay wxpay

      payStatus: 0, // 0 支付类型，1 支付二维码，3 支付成功
      payLoading: false,

      payData: { // 支付数据
        orderNo: '',
        qrcode: '',
      },
      errorText: '二维码生成失败',

      showInvalidCode: false, // 显示 无效码
      resultMessage: '等待支付',
      countdown: 0, // 倒计时
      timer: null, // 倒计时定时器
      pollTimer: null, // 轮询定时器
      // 配置参数
      totalTimeout: 600, // 总倒计时时间（秒） 10分钟 600  2小时 7200
      pollInterval: 3,  // 轮询间隔（秒）
      maxAttempts: 0,   // 最大轮询次数计算（totalTimeout/pollInterval）
    };
  },
  created() {
    // 从localStorage中获取用户id
    this.userId = localStorage.getItem('at_userId') || '';
    // 计算最大轮询次数
    this.maxAttempts = Math.ceil(this.totalTimeout / this.pollInterval);
  },
  computed: {
    paymentText() {
      let prefixText = this.dialogEnum[this.payType]?.prefix;
      let priceText = `可支付${ this.getPrice() }元/次获取。`;
      return prefixText && priceText ? prefixText + priceText : '您的访问次数已达上限，如需继续使用，可付费后获取。';
    },
    formattedTime() {
      const s = this.countdown;
      if (s <= 0) return '0秒';
      if (s < 60) return `${s}秒`;

      const m = Math.floor(s / 60);
      const sec = s % 60;

      return sec === 0 ? `${m}分` : `${m}分${sec}秒`;
    },
    totalPriceInFen() {
      const priceInFen = Math.round(this.getPrice() * 100); // 将元转为分
      return priceInFen * this.orderQuantity;
    },
    totalPriceDisplay() {
      return (this.totalPriceInFen / 100).toFixed(2).replace(/\.?0+$/, '');
    },
  },
  methods: {
    // 获取单价
    getPrice() {
      return getQuotaObj(this.payType)['price'];
    },

    // 打开弹窗
    open() {
      this.visible = true;
    },

    // 关闭弹窗
    close() {
      this.activeType = "alipay";
      this.payStatus = 0;
      this.payData = { orderNo: "", qrcode: "" };
      this.errorText = '二维码生成失败';
      this.reset();
      this.visible = false;
      if (this.payType === '人才详情') {
        location.reload();
      }
    },

    // 关闭二次确认
    confirmClose() {
      if (this.payStatus !== 2 && this.resultMessage === '等待支付') {
        this.$confirm('您还未支付，确认关闭当前页？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.stopPolling();
          this.close();
        }).catch(() => {});
      } else {
        this.close();
      }
    },

    // 回到第一步
    handleBack() {
      this.payStatus = 0;
      this.activeType = "alipay";
      this.payData = { orderNo: "", qrcode: "" };
      this.orderQuantity = 1;
      this.errorText = '二维码生成失败';
      this.reset();
    },

    // 切换支付类型
    changePay(current) {
      // TODO 微信支付
      if (current === 'wxpay') {
        this.$message.warning('功能开发中～');
        return false;
      }
      this.activeType = current;
    },

    // 去支付
    handlePayment() {
      // 防止重复点击
      this.reset();
      this.payLoading = true;

      const { id, label, path } = getQuotaObj(this.payType);
      if (!id || !label || !path) {
        this.$message.warning('缺少商品参数，请刷新后重试');
        this.payLoading = false;
        return false;
      }

      // 支付宝、微信
      let payApi = this.activeType === 'alipay' ? alipayQrcodeApi : null;
      let pa = {
        quotaId: Number(id),
        quotaLabel: label,
        quotaPath: path,
        orderQuantity: Number(this.orderQuantity), // 数量
      };
      payApi(pa).then(res => {
        if (res.data.orderNo && res.data.qrcode) {
          this.payData.orderNo = res.data.orderNo;
          this.payData.qrcode = res.data.qrcode;
          this.payStatus = 1;
          this.startPolling(); // 启动轮询
        } else {
          this.payData.orderNo = '';
          this.payData.qrcode = '';
        }
        // 初始化数量
        this.orderQuantity = 1;
      }).catch(() => {
        this.$message.warning('二维码生成失败，请稍后重试');
      }).finally(() => {
        this.payLoading = false;
      });
    },

    // 开始轮询订单状态
    startPolling() {
      // 清理定时器
      this.reset();

      this.countdown = this.totalTimeout;

      // 开始倒计时
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          // 倒计时结束时执行超时处理
          this.handleTimeout();
        }
      }, 1000);

      // 立即执行第一次查询
      this.checkPayStatus();

      // 开始定期轮询
      this.pollTimer = setInterval(() => {
        this.checkPayStatus();
      }, this.pollInterval * 1000);
    },

    // 查询订单状态
    /**
     * ORDER_NOT_EXIST: 订单不存在                         停止轮询
     * ORDER_CREATED: 订单创建                             继续轮询
     * WAIT_BUYER_PAY: 交易创建，等待买家付款                继续轮询，显示“请扫码支付”
     * TRADE_SUCCESS: 交易成功                             停止轮询，显示“支付成功”
     * TRADE_CLOSED: 未付款交易超时关闭，或支付完成后全额退款   停止轮询，显示“支付超时”
     * TRADE_FINISHED: 交易结束，不可退款                   停止轮询，显示“订单已关闭”
     */
    checkPayStatus() {
      // console.log(`轮询查询订单状态，订单ID: ${this.payData.orderNo}，倒计时剩余时间: ${this.countdown}秒`);

      // 支付宝、微信
      let payStatusApi = this.activeType === 'alipay' ? alipayStatusApi : null;
      let pa = { orderNo: this.payData.orderNo };

      payStatusApi(pa).then(res => {
        const status = res.data;

        switch (status) {
          case 'TRADE_SUCCESS':
            this.handlePayResult('success');
            break;
          case 'TRADE_CLOSED':
            this.handlePayResult('closed');
            break;
          case 'TRADE_FINISHED':
            this.handlePayResult('finished');
            break;
          case 'ORDER_NOT_EXIST':
            this.handlePayResult('not_exist');
            break;
          case 'ORDER_CREATED':
          case 'WAIT_BUYER_PAY':
            this.resultMessage = '等待支付';
            break;
          default:
            console.warn('未知支付状态:', status);
        }

      }).catch((e) => {
        console.warn('轮询支付状态失败:', e);
        // 即使出错也不停止轮询，倒计时结束会自动停止轮询
      })
    },

    // 停止所有轮询
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    // 重置状态（轮询、定时器）
    reset() {
      this.stopPolling();
      this.resultMessage = '等待支付';
      this.showInvalidCode = false;
      this.countdown = 0;
    },

    // 取消订单
    payClose() {
      let pa = { orderNo: this.payData.orderNo };
      alipayCloseApi(pa).then(res => {
        console.log(res);
        // if (res.data) {
        //   this.$message.success('订单关闭成功');
        // } else {
        //   this.$message.info('订单关闭失败');
        // }
      });
    },

    // 统一处理支付异常或结束状态
    handlePayResult(status) {
      this.stopPolling();
      this.countdown = 0;
      // this.payData.qrcode = '';

      const messages = {
        success: '支付成功',
        closed: '支付失败或超时，交易关闭',
        finished: '订单已关闭',
        not_exist: '订单不存在',
      };

      const msg = messages[status] || '未知错误，请稍后重试';
      this.resultMessage = this.errorText = msg;

      // 如果是成功，进入成功页面
      if (status === 'success') {
        this.payStatus = 2;
      } else {
        this.showInvalidCode = true;
      }
    },

    // 倒计时结束处理
    handleTimeout() {
      this.stopPolling();

      // 调用 取消订单
      // this.payClose();

      // 倒计时结束，关闭订单
      this.resultMessage = this.errorText = '支付超时';
      this.showInvalidCode = true;
      // this.payData.qrcode = '';
    },
  },
  watch: {
    payType: {
      handler(val) {
        this.subject = val;
      },
      immediate: true,
      deep: true,
    }
  },
  beforeDestroy() {
    // 组件销毁前清理定时器
    this.stopPolling();
  },
  deactivated() {
    // 确保清理定时器，兼容 keep-alive 缓存组件的情况
    this.stopPolling();
  },
};
</script>

<style scoped lang="less">
.confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2002;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .3s linear;
  user-select: none !important;
}

.confirm-container {
  background: #fff;
  border-radius: 16px;
  padding: 16px 0 20px;
  width: 520px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.confirm-header {
  text-align: center;
  h3 {
    color: #444;
    padding-bottom: 14px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    letter-spacing: 2px;
    user-select: none;
  }
  .el-icon-close {
    right: 20px;
    top: 0;
    font-size: 18px;
    color: #999999;
    cursor: pointer;
    &:hover {
      color: #444444;
    }
  }
}
.confirm-content {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  text-align: center;

  .el-input {
    background-color: var(--background-left_navigation_web);
    border-color: var(--widget-line);
    border-radius: 8px;
    color: var(--text-text_primary);
    height: 100% !important;
    min-height: 112px !important;
    padding: 12px;
    word-break: break-all;
  }

  .el-icon-arrow-left {
    left: 20px;
    top: 3px;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      color: #1241C9;
    }
  }

  p {
    line-height: 18px;
    font-size: 14px;
    padding: 4px 0;
  }

  .order-quantity {
    padding: 30px 0 20px;
    .Price {
      text-align: center;
      color: #1241C9;
      font-size: 23px;
      margin-right: 14px;
      margin-left: 10px;
    }
    /deep/ .el-input-number {
      .el-input__inner {
        border-color: #DCDFE6 !important;
      }
    }
  }

  .payment-type {
    width: 300px;
    margin: 20px auto;
    .aliPay, .wxPay {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .wxPay {
      margin-top: 18px;
    }
    img {
      display: inline-block;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
    }
    span {
      display: inline-block;
      width: 120px;
      font-size: 14px;
      text-align: left;
      font-weight: 500;
      padding-left: 12px;
    }
    i {
      color: #cccccc;
    }
  }
  .active {
    color: #1241C9 !important;
  }
}

.qrcode-mask {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.8);
  .reinitiate-btn {
    width: 60px;
    font-style: normal;
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 12px;
    background: #1241C9;
  }
  p {
    font-weight: 600;
    font-size: 13px;
    color: #ffffff;
    margin-top: 6px;
  }
}



.warning-icon {
  color: #e6a23c;
  font-size: 24px;
  margin-bottom: 10px;
}

.message {
  margin-bottom: 20px;
  font-size: 16px;
  color: #606266;
}

.buttons {
  text-align: center;
  width: 100%;
  margin: 26px 0 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.el-button--default {
  color: #333 !important;
  background-color: #fff !important;
  border-color: #fff !important;

  &:hover {
    background-color: rgba(65, 70, 76, 0.05) !important;
    border-color: rgba(65, 70, 76, 0.05) !important;
  }
}


.blur-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background:
    linear-gradient(45deg, rgba(0, 0, 0, 0.3) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(0, 0, 0, 0.3) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.3) 75%),
    linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.3) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  mix-blend-mode: multiply;

  //filter: blur(1px);
  z-index: 1;
}
</style>
